import { isStaleChunkError as e } from "./isStaleChunkError.mjs";
import { reloadForStaleChunk as t } from "./reloadForStaleChunk.mjs";
import { ChunkLoadError as n } from "./ChunkLoadError.mjs";
import { lazy as r } from "react";
//#region src/staleChunk/lazyWithRetry.ts
var i = [400, 1200], a = (e) => new Promise((t) => setTimeout(t, e));
function o(e) {
	let t = e?.default;
	if (typeof t == "function" || typeof t == "object" && t) return e;
	throw new n("Lazy module resolved without a component default export");
}
function s(e) {
	return e instanceof Error ? e.message : String(e);
}
async function c(r, c = i) {
	let l;
	for (let t = 0; t <= c.length; t += 1) {
		t > 0 && await a(c[t - 1] ?? 0);
		try {
			return o(await r());
		} catch (t) {
			if (!e(t)) throw t;
			l = t;
		}
	}
	if (t("lazy-import", s(l))) return new Promise(() => {});
	throw l instanceof n ? l : new n(s(l), l);
}
function l(e) {
	return r(() => c(e));
}
//#endregion
export { l as lazyWithRetry, c as loadWithRetry };
